export default function () {
	var handleChange = function (e) {
		var a = document.querySelector(".ask-us__button--download");
		a.href = e.target.value;
	}
  
	let chooseContactFrom = document.querySelector(".ask-us__select");
	if (chooseContactFrom) {
	  chooseContactFrom.addEventListener("change", handleChange);
	}
  }
